import { Stack } from "@mui/material";
import DocumentListCard from "./DocumentListCard";

const RaciDashboard = ({ type }) => {
  return (
    <Stack direction="row" spacing={2} paddingBottom={2}>
      <DocumentListCard type={type} />
    </Stack>
  );
};

export default RaciDashboard;
